/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import ProductPageDataConfig from '../../config/feature-section.config.json';
import footerConfig from '../../config/footer.config.json';
import headerConfig from '../../config/header.config.json';
import heroSectionConfig from '../../config/hero-section.config.json';
import howItWorksConfig from '../../config/how-it-works.config.json';
import imageSectionConfig from '../../config/image-feature-section.config.json';
import mainSectionConfig from '../../config/main-section.config.json';

export interface IProductPageDataMethods extends IPluginMethodMap {
  getProductPageData(): Promise<any>;
}

export class ProductPageDataService implements IAgentPlugin {
  readonly methods: IProductPageDataMethods;

  constructor() {
    this.methods = {
      getProductPageData: this.getProps.bind(this),
    };
  }

  async getProps() {
    return {
      ...(headerConfig || {}),
      ...(ProductPageDataConfig || {}),
      ...(heroSectionConfig || {}),
      ...(howItWorksConfig || {}),
      ...(mainSectionConfig || {}),
      ...(imageSectionConfig || {}),
      ...(footerConfig || {}),
    };
  }
}
